export default __webpack_public_path__ + "static/media/appointmentbutton.f4d49fb4.svg";